import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';

import logRocketPromise, { LogRocketInstance } from '@/services/logRocket';

interface RejectedPayload {
  readonly status?: number | string;
  readonly data?: {
    readonly code?: string;
    readonly message?: string;
  };
}

interface RejectedMeta {
  readonly arg?: {
    readonly endpointName?: string;
    readonly type?: string;
  };
}

interface ApiErrorInfo {
  readonly endpoint: string;
  readonly status: number | string;
  readonly code: string;
  readonly requestType: string;
}

const extractErrorInfo = (action: { payload?: unknown; meta?: unknown }): ApiErrorInfo => {
  const payload = (action.payload ?? {}) as RejectedPayload;
  const meta = (action.meta ?? {}) as RejectedMeta;

  return {
    code: payload.data?.code ?? 'unknown',
    endpoint: meta.arg?.endpointName ?? 'unknown',
    requestType: meta.arg?.type ?? 'unknown',
    status: payload.status ?? 'unknown',
  };
};

type Next = (action: unknown) => unknown;

export const logRocketMiddleware: Middleware =
  () =>
  (next: Next) =>
  (action: unknown): unknown => {
    if (isRejectedWithValue(action)) {
      const info = extractErrorInfo(action);

      void logRocketPromise.then((logRocket: LogRocketInstance): void => {
        logRocket.captureMessage(`api_error: ${info.endpoint}`, {
          extra: {
            code: info.code,
            endpoint: info.endpoint,
            requestType: info.requestType,
            status: String(info.status),
          },
        });

        logRocket.track('api_error', {
          code: info.code,
          endpoint: info.endpoint,
          requestType: info.requestType,
          status: String(info.status),
        });
      });
    }

    return next(action);
  };
